import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import SEO from "./seo.component";
import pageSEO from "../constants/pageSEO";

export default function About() {
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentAbout,
    getCurrentHeadshot,
  } = useUserParams();

  const aboutContent =
    getCurrentAbout() || constants.FULL_ABOUT || constants.ABOUT || "";
  const aboutParagraphs = aboutContent
    ? aboutContent.split("<|>")
    : [];

  const seoConfig = pageSEO.about();

  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] mx-auto gap-x-20 gap-y-10 px-6 grid sm:grid-cols-2 mb-12 min-h-[70vh] pt-[150px]">
        <div>
          <img src={getCurrentHeadshot()} className="w-full rounded-xl" />
          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-3xl">{getCurrentAgentName()}</h2>
            <p className="italic text-lg">
              {[getCurrentAgentTitle(), getCurrentBrokerage()]
                .filter(Boolean)
                .join(", ")}
            </p>

            <div className="flex gap-x-5 my-2">
              {Object.entries(constants.SOCIALS ?? {}).filter(([k, v]) => v !== "")?.map(([k, v]) => (
                <a href={constants.SOCIALS[k]}>
                  <FontAwesomeIcon
                    className="fa-xl text-logo-second"
                    icon={constants.ICONS[k]}
                  />
                </a>
              ))}
            </div>
            <p className="font-semibold text-lg">
              <FontAwesomeIcon icon={faPhone} className="pr-2" />
              {getCurrentAgentNumber()} {" "}
            </p>
            <p className="text-lg">
              <FontAwesomeIcon icon={faEnvelope} className="pr-2" />
              {getCurrentAgentEmail()} {" "}
            </p>
          </div>
        </div>
        <div>
          <h1 className="text-4xl text-black pb-8 font-mont ">ABOUT ME</h1>

          {aboutParagraphs.length ? (
            aboutParagraphs.map((p, index) => (
              <p key={index}>
                {p}
                <br />
                <br />
              </p>
            ))
          ) : (
            <p>Coming Soon</p>
          )}
        </div>
      </div>
    </>
  );
}
